import { useCallback } from "react";
import { useField } from "formik";
import { EfsMelcoEfsModelsMappingFileAttribute } from "melco-shared-logic";

export const useFilenameRules = () => {
  const [{ value: filenameRules }, , { setValue: setFilenameRules }] = useField<
    EfsMelcoEfsModelsMappingFileAttribute[]
  >("filename_rules_list");

  const addFilenameRule = useCallback(
    (filenameRule: EfsMelcoEfsModelsMappingFileAttribute) => {
      setFilenameRules([...(filenameRules ?? []), filenameRule]);
    },
    [filenameRules, setFilenameRules]
  );

  const updateFilenameRuleAtIndex = useCallback(
    (index: number, filenameRule: EfsMelcoEfsModelsMappingFileAttribute) => {
      setFilenameRules(
        filenameRules.map((fr, idx) => {
          if (idx === index) {
            return { ...filenameRule };
          }

          return fr;
        })
      );
    },
    [filenameRules, setFilenameRules]
  );

  const removeFilenameRules = useCallback(
    (indicesToRemove: number[]) => {
      setFilenameRules(
        filenameRules.filter((_, idx) => !indicesToRemove.includes(idx))
      );
    },
    [filenameRules, setFilenameRules]
  );

  return {
    filenameRules,
    addFilenameRule,
    updateFilenameRuleAtIndex,
    removeFilenameRules,
  };
};
